import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IKeyValuePair} from "../../../interfaces/IKeyValuePair";
import {IOptionSetConfig} from "../../../interfaces/IOptionSetConfig";

@Component({
  selector: 'app-yes-no-toggle',
  templateUrl: './yes-no-toggle.html',
  styleUrls: ['./yes-no-toggle.css'],
})
export class YesNoToggleComponent implements OnInit {
  @Input() isChecked: boolean;
  @Input() isDisabled: boolean = false;
  @Input() isRequired: boolean = false;
  @Input() id:string;
  @Input() text:string;
  @Output() change = new EventEmitter<boolean>();



  options = [
    {
      Key: 'Yes',
      Value: true,
    },
    {
      Key: 'No',
      Value: false,
    }
  ];
  config: IOptionSetConfig;

  ngOnInit(): void {
    this.config = {
      displayKey: 'Key',
      search: false,
      placeholder: this.isChecked ? 'Yes' : 'No',
      noResultsFound: '',
      searchPlaceholder: '',
    }
  }
}
